module.exports = __webpack_public_path__ + "static/media/Banner_Image_desk.341ccfff.png";